// src/types/bookings/BookingInvitation.ts
var BookingInvitationStatus = /* @__PURE__ */ ((BookingInvitationStatus2) => {
  BookingInvitationStatus2["Pending"] = "pending";
  BookingInvitationStatus2["Accepted"] = "accepted";
  BookingInvitationStatus2["Declined"] = "declined";
  BookingInvitationStatus2["Expired"] = "expired";
  BookingInvitationStatus2["Cancelled"] = "cancelled";
  return BookingInvitationStatus2;
})(BookingInvitationStatus || {});

export {
  BookingInvitationStatus
};
